import { FC } from 'react';

import ErrorIcon from './ErrorIcon';
import Message from './Message';

export type ErrorMessageProps = {
  title?: string;
  message?: string;
};

const ErrorMessage: FC<ErrorMessageProps> = ({
  title = 'contactFormTitleErrorMessage',
  message = 'contactFormErrorMessage'
}) => {
  return (
    <Message
      title={title}
      message={message}
      icon={<ErrorIcon />}
    />
  );
};

export default ErrorMessage;
